import { Component, Input, OnInit } from '@angular/core';

import { IOrderDelivery } from '@cakeiteasy/web-utils';

import { CART_DELIVERY_TYPES } from '../../../cart/constants/common';

/**Renders the delivery or pickup details of an order.
 * Callers must not render it for orders without delivery details — see hasDeliveryDetails() */
@Component({
  standalone: false,
  selector: 'order-delivery-info-block',
  templateUrl: './order-delivery-info-block.component.html',
  styleUrls: ['./order-delivery-info-block.component.scss'],
})
export class OrderDeliveryInfoBlockComponent implements OnInit {
  @Input() deliveryOrder: IOrderDelivery;
  @Input() currency: string;

  public isToDoor: boolean;
  public isPickup: boolean;

  ngOnInit() {
    this.isToDoor = this.deliveryOrder.type === CART_DELIVERY_TYPES.DELIVERY;
    this.isPickup = this.deliveryOrder.type === CART_DELIVERY_TYPES.PICKUP;
  }
}
